import {FetchCheckUserCodeIsExist} from "_private/api/systemSetting/userManage";
import individuationValidate from "@/utils/validate";

const object = require("lodash/fp/object");

// 校验用户名的唯一性
const CheckUserCodeIsExist = function (rule, value, callback) {
    FetchCheckUserCodeIsExist({userCode: value})
        .then(response => {
            if (response.code === 1) {
                callback();
            } else {
                callback(new Error(response.message));
            }
        })
        .catch(error => {
            console.log(error);
        });
};
// 验证长度为8-16位的字母或数字组成（只能输入字母或数字）
export const CheckVehicleIdentificationNo = function(rule, value, callback) {
  if(!value) {
    callback();
  }else {
  if(value.indexOf(" ") != -1) {
    callback(new Error("请勿输入空格"))
  }
  if (/^[a-zA-Z0-9]{8,16}$/.test(value)) {
    callback();
  } else {
    callback(new Error("请输入8-16位数字或字母"));
  }
}
};
// 校验qq
export const CheckIsQQ = function (rule, value, callback) {
    if (value === "") {
        callback();
    } else {
        if (RegExp(/^[1-9][0-9]{4,9}$/).test(value)) {
            callback();
        } else {
            callback(new Error("请输入正确QQ"));
        }
    }
};

const _privateValidate = {
    CheckUserCodeIsExist,
    CheckIsQQ,
    CheckVehicleIdentificationNo
};
const validate = object.merge(_privateValidate, individuationValidate);
export default validate;
